const validate = (value, args) => {
  let result = false
  if (typeof value === 'number') {
    value = value.toString()
  } else if (typeof value !== 'string') {
    value = ''
  }
  if (!!value.length && value.length === 9 && /^[0-9]{4}[0-9A-Z]{2}[0-9]{3}$/.test(value)) {
    result = true
  }
  return result
}

export default {
  validate
}
